import React, { useEffect, useState } from "react";
import { AdministracaoPageContainer } from "./styles";
import DefaultButton from "../../../shared/util/DefaultButton";
import { FaPlus, FaDatabase } from "react-icons/fa";
import RoleList from "../components/RoleList";
import AdminTabMenu from "../components/TabMenu";
import CategoryList from "../components/Category";
import DimensionList from "../components/Dimension";
import Report from "../components/Report";
import StageList from "../components/Stage";
import UserList from "../../usuario/components/UserList";
import ChallengeList from "../components/Challenge";
import UseTermList from "../components/UseTerm/components/UseTermList";
import { useSelection } from "../../../shared/context/selection/selectionProvider";
import TenantList from "../components/Tenant/components/List";
import DashboardView from "../components/Dashboard";
import ImportModal from "../components/ImportModal";

function AdministracaoPage(): JSX.Element {
  const [openAddUser, setOpenAddUser] = useState(false);
  const [openAddRole, setOpenAddRole] = useState(false);
  const [openAddCategory, setOpenAddCategory] = useState(false);
  const [openAddUseTerm, setOpenAddUseTerm] = useState(false);
  const [openAddDimension, setOpenAddDimension] = useState(false);
  const [openAddStage, setOpenAddStage] = useState(false);
  const [openAddChallenge, setOpenAddChallenge] = useState(false);
  const [openAddTenant, setOpenAddTenant] = useState(false);
  const [menuActive, setMenuActive] = useState("permissoes");
  const [importModalVisible, setImportModalVisible] = useState(false);

  const { administrationActiveMenu } = useSelection();

  const createButtonVisibleWhen = ["usuarios", "permissoes", "categorias", "dimensao", "fases", "desafios", "termosdeuso", "tenant"];

  useEffect(() => {
    if (administrationActiveMenu) {
      setMenuActive(administrationActiveMenu);
    }
  }, [administrationActiveMenu]);

  function handleCreateButton(value: boolean) {
    if (menuActive === "usuarios") setOpenAddUser(value);
    if (menuActive === "permissoes") setOpenAddRole(value);
    if (menuActive === "categorias") setOpenAddCategory(value);
    if (menuActive === "dimensao") setOpenAddDimension(value);
    if (menuActive === "fases") setOpenAddStage(value);
    if (menuActive === "desafios") setOpenAddChallenge(value);
    if(menuActive === "termosdeuso") setOpenAddUseTerm(value);
    if(menuActive === "tenant") setOpenAddTenant(value);
  }

  function renderCreateButtonName() {
    if (menuActive === "usuarios") return "Novo Usuário";
    if (menuActive === "permissoes") return "Nova Permissão";
    if (menuActive === "categorias") return "Nova Categoria";
    if (menuActive === "desafios") return "Novo Desafio";
    if (menuActive === "dimensao") return "Nova Dimensão";
    if (menuActive === "fases") return "Nova Fase";
    if (menuActive === "termosdeuso") return "Novo Termo de Uso";
    if (menuActive === "tenant") return "Novo Tenant";
  }

  return (
    <AdministracaoPageContainer>
      <div className="header-criar-role">
        {createButtonVisibleWhen.includes(menuActive) ? (
          <>
            <DefaultButton
            minWidth="170px"
            height="35px"
            fontSize="1em"
            onMobileFullWidth={true}
            params={{
              onClick: () => handleCreateButton(true),
            }}
          >
            <FaPlus />
            {renderCreateButtonName()}
          </DefaultButton>
          {menuActive === "tenant" && (
            <DefaultButton
              minWidth="100px"
              height="35px"
              fontSize="1em"
              marginLeft="10px"
              onMobileFullWidth={true}
              params={{
                onClick: () => setImportModalVisible(true)
              }}
            >
              <FaDatabase />
              Importar
            </DefaultButton>
          )}
          </>
        ) : (
          menuActive !== "relatorio" && menuActive !== "dashboard" && (
            <DefaultButton
            width="220px"
            height="35px"
            fontSize="1em"
            padding="1.5rem"
            params={{
              disabled: true,
            }}
          >
            <FaPlus />
            {renderCreateButtonName()}
          </DefaultButton>
          )
        )}
      </div>

      <section>
        <AdminTabMenu
          active={menuActive}
          setActive={setMenuActive}
        />
        {menuActive === "usuarios" && (
          <UserList
            openAddUser={openAddUser}
            setOpenAddUser={setOpenAddUser}
          />
        )}

        {menuActive === "permissoes" && (
          <RoleList
            openAddRole={openAddRole}
            setOpenAddRole={setOpenAddRole}
          />
        )}

        {menuActive === "categorias" && (
          <CategoryList
            openAddCategory={openAddCategory}
            setOpenAddCategory={setOpenAddCategory}
          />
        )}

        {menuActive === "dimensao" && (
          <DimensionList
            openAddDimension={openAddDimension}
            setOpenAddDimension={setOpenAddDimension}
          />
        )}

        {menuActive === "fases" && (
          <StageList
            openAddStage={openAddStage}
            setOpenAddStage={setOpenAddStage}
          />
        )}

        {menuActive === "desafios" && (
          <ChallengeList
            openAddChallenge={openAddChallenge}
            setOpenAddChallenge={setOpenAddChallenge}
          />
        )}

        {menuActive === "termosdeuso" && (
          <UseTermList
            openAddUseTerm={openAddUseTerm}
            setOpenAddUseTerm={setOpenAddUseTerm}
          />
        )}

        {menuActive === "tenant" && (
          <TenantList
            openAddTenant={openAddTenant}
            setOpenAddTenant={setOpenAddTenant}
          />
        )}

        {menuActive === "relatorio" && (
          <Report/>
        )}

        {menuActive === "dashboard" && (
          <DashboardView />
        )}
      </section>

      <ImportModal
        visible={importModalVisible}
        onCancel={() => setImportModalVisible(false)}
        onSuccess={() => setImportModalVisible(false)}
      />
    </AdministracaoPageContainer>
  );
}

export default AdministracaoPage;